import { nip19 } from 'nostr-tools';
import { Navigate, useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { NotePage } from './NotePage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'note': {
      const id = decoded.data as string;
      return <NotePage id={id} />;
    }

    case 'nevent': {
      const { id } = decoded.data as { id: string; relays?: string[]; author?: string; kind?: number };
      return <NotePage id={id} />;
    }

    case 'npub':
    case 'nprofile':
      // This is a single-archive app; profile links point back to the index.
      return <Navigate to="/" replace />;

    case 'naddr':
      return <NotFound />;

    default:
      return <NotFound />;
  }
}
